var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoLocation = function SvgNoLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 111,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.456 42.12c-8.38 0-16.89-.34-24.86-2.56-7.82-2.17-15-6.38-21.4-11.25-4.2-3.17-8-5.7-13.45-5.32a24.86 24.86 0 0 0-14.51 5.7c-6.93 6.06-5.88 17.27-3.12 25.15 4.17 11.87 16.82 20.12 27.59 25.49 12.43 6.21 26.08 9.79 39.78 11.89 12 1.83 27.41 3.15 37.81-4.68 9.56-7.2 12.18-23.65 9.84-34.75a13.66 13.66 0 0 0-4.92-8.32c-6.71-4.91-16.72-1.63-24.26-1.47-2.8.12-5.64.12-8.5.12M58.966 110.68c20.275 0 36.71-1.025 36.71-2.29s-16.435-2.29-36.71-2.29c-20.274 0-36.71 1.025-36.71 2.29s16.436 2.29 36.71 2.29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M32.986 92.41a.98.98 0 1 0 0-1.96.98.98 0 0 0 0 1.96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M89.326 97.42v4.3M87.166 99.57h4.31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M57.386 1a40 40 0 0 0-40 40c0 29.36 40 56.85 40 56.85s40-27.07 40-56.85a40 40 0 0 0-40-40m0 55a15.76 15.76 0 1 1 15.76-15.8 15.77 15.77 0 0 1-15.76 15.76z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.066 8.41v4.3M12.906 10.56h4.31M104.586 20.11v4.3M102.426 22.26h4.31M62.696 34.35l-10.62 10.63M52.076 34.35l10.62 10.63"
  })));
};
export default SvgNoLocation;